import cn from 'clsx';
import Link from 'next/link';
import {useRouter} from 'next/router';
import PropTypes from 'prop-types';
import {memo, useMemo} from 'react';

import {
  ORDER_BY_FILTER,
  ORDER_FILTER,
  SEARCH_FILTERS,
} from '@/src/app/constants/search';
import getLastDirectoryFromUrl from '@/src/app/utils/getLastDirectoryFromUrl';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Text} from '../../ui';
import css from '../styles/SearchTabs.module.css';

const SearchTabs = ({title, tabs}) => {
  const {query, locale, asPath} = useRouter();

  const slug = getLastDirectoryFromUrl(asPath);

  const tabsNode = useMemo(() => {
    return tabs?.map(({id, titleID, count, url}) => {
      const isActive = url.split('/').pop().includes(slug);

      return (
        <Link
          key={id}
          href={`${url}?${SEARCH_FILTERS.OFFSET}=0&${SEARCH_FILTERS.ORDER}=${ORDER_FILTER.DESC}&${SEARCH_FILTERS.ORDER_BY}=${ORDER_BY_FILTER.APPROVED_AT}&${SEARCH_FILTERS.LANGUAGE}=${locale}`}
        >
          <a
            className={cn(css.switchItem, {
              [css.activeSwitchItem]: isActive,
            })}
          >
            <TextLocal id={titleID} params={{count}} />
          </a>
        </Link>
      );
    });
  }, [tabs, query.slug]);

  return (
    <div className={css.widget}>
      <Text
        tagComponent={Text.TAG.H1}
        fontSize={Text.FONT_SIZE.SIZE_32}
        fontWeight={Text.FONT_WEIGHT.MEDIUM}
        fontFamily={Text.FONT_FAMILY.RUBIK}
        color={Text.COLOR.PRIMARY}
      >
        <TextLocal id={title} />
      </Text>
      <div className={css.card}>
        <div className={css.followersSwitcher}>{tabsNode}</div>
      </div>
    </div>
  );
};

SearchTabs.propTypes = {
  title: PropTypes.string,
  tabs: PropTypes.array.isRequired,
};

SearchTabs.defaultProps = {
  tabs: [],
};

export default memo(SearchTabs);
